<table ixTest="table">
  <ng-content></ng-content>
</table>
